export default __webpack_public_path__ + "static/media/telegramcalltoactionempty-01.80474ec5.svg";